import { Button, Container, Flex, Heading, ScrollArea, Spinner, Text, TextArea, TextField } from "@radix-ui/themes";
import {useNavigate, useSearchParams} from 'react-router'
import useFetch from '../../core/hooks/useFetch'
import UserService from '../../core/services/UserService'
import React, { useEffect, useRef, useState } from "react";
import { IUser } from "../../core/types/services-types/user-types";
import UserCardRender from '../../components/common/renders/user-card-render'
import {Cross1Icon, MagnifyingGlassIcon} from '@radix-ui/react-icons'
import {ITransaction} from '../../core/types/services-types/transaction-types'
import { OtpInput, OtpInputHandle } from 'reactjs-otp-input';
import TransactionService from "../../core/services/TransactionService";
import { toast } from "react-toastify";
import { ROUTES } from "../../routes/constants";
export default function SendMoneysSiteToUser() {
    const [searchParams, setSearchParams] = useSearchParams()
    const [chatId, setChatId] = useState<string | number | null>(searchParams.get('user_id'))
    const [transactionId, setTransactionId] = useState<string | null>(searchParams.get("transaction_id"))
    const navigate = useNavigate()
    const [users, setUsers] = useState<IUser[]>([])
    const [selectedUser, setSelectedUser] = useState<IUser | null>()
    const [nameUser, setNameUser] = useState<string>('')
    const [limitUsers, setLimitUsers] = useState<number>(100)
    const [pageUsers, setPageUsers] = useState<number>(0)
    const [transaction, setTransaction] = useState<ITransaction | null>()
    const [amount, setAmount] = useState<string>('')
    const [message, setMessage] = useState<string>('')
    const [mfa, setMfa] = useState<string>('')
    const refOtp = useRef<OtpInputHandle>(null)


    const clearTransaction = () => {
        setSelectedUser(null)
        setTransaction(null)
    }

    const [fetchUsers, isLoading, error, errors] = useFetch(async () => {
            const data = await UserService.GetUserForLoginMatch(nameUser, limitUsers, pageUsers)
            if(data.users.length) setUsers(data.users)
    })


    const [fetchUser, isLoadingUser, errorUser, errorsUser] = useFetch(async () => {
        if(chatId) {
        const user = await UserService.Get(chatId)
        setSelectedUser(user)
        }

    })


        const [fetchSendMoneys, isLoadingFetchSendMoneys, errorFetchSendMoneys, errorsFetchSendMoneys] = useFetch(async () => {
            if(selectedUser && amount && message) {
            const data = await TransactionService.SendCurrencySiteToUserRequest(amount, message, selectedUser.id)
            setTransaction(data.transaction)
            toast.success(data.message)
        }
        })

        const [fetchTransaction, isLoadingFetchTransaction, errorFetchTransaction, errorsFetchTransaction] = useFetch(async () => {
            if(transactionId) {
            const data = await TransactionService.Get(transactionId)
            if(data.status === 'success') {
                toast.info("Транзакция уже подтверждена!")
                return
            }
            setTransaction(data)
            setAmount(data.amount.toString())
            setChatId(data.to)
            if(!selectedUser) {
                await fetchUser()
            }
        }
        })
    
        const [fetchSendMoneysFinish, isLoadingFetchSendMoneysFinish, errorFetchSendMoneysFinish, errorsFetchSendMoneysFinish] = useFetch(async () => {
            if(transaction) {
            const data = await TransactionService.SendCurrencySiteToUserFinish(transaction.id, mfa)
            toast.success(data.message)
            navigate(ROUTES.ACCOUNT_ROUTE)
            }
        })
    
        const [fetchSendNewCode, isLoadingSendNewCode, errorFetchSendNewCode, errorsFetchSendNewCode] = useFetch(async () => {
            if(transaction) {
            const data = await TransactionService.RequestNewCodeForSendCurrencySiteToUser(transaction.id)
            toast.success(data.message)
            }
        })

    const navigateUser = () => {
        navigate(`/profile/${selectedUser?.id}`)
    }

     useEffect(() => {
            fetchUsers()
        }, [nameUser])

        useEffect(() => {
            if(refOtp.current) refOtp.current.focusInput = (index: number) => 1
        }, [refOtp.current])


           useEffect(() => {
                if(errorFetchSendMoneys.length) {
                    toast.error(errorFetchSendMoneys)
                }
            }, [errorFetchSendMoneys])
        
            useEffect(() => {
                if(errorFetchSendMoneysFinish.length) {
                    toast.error(errorFetchSendMoneysFinish)
                }
            }, [errorFetchSendMoneysFinish])
        
            useEffect(() => {
                if(errorFetchSendNewCode.length) {
                    toast.error(errorFetchSendNewCode)
                }
            }, [errorFetchSendNewCode])


    useEffect(() => {
        if(transactionId?.length) {
        fetchTransaction()
        }
    }, [transactionId])

    useEffect(() => {
        if(chatId) {
        fetchUser()
        }
    }, [chatId])
    return (
        <Container className="p-5">
            <Container className="heading-wrapper mb-5">
                <Heading>Отправка внутренней валюты</Heading>
           
            <hr />
            </Container>
            <Container>
                <Container>
                    <TextField.Root placeholder="Поиск по логину" value={nameUser} onChange={e => setNameUser(e.target.value)}>
                        <TextField.Slot>
                            <MagnifyingGlassIcon />
                        </TextField.Slot>
                    </TextField.Root>
                    { users.length && !selectedUser ?
                    <ScrollArea type="always" scrollbars="vertical" style={{height: '200px'}} className="mb-5">
                        {users.map(item => <UserCardRender user={item} onClick={setSelectedUser} />)}
                    </ScrollArea>
                    :
                    ''
                    }
                </Container>
                {
                isLoading ? <Spinner size={'3'} /> : ''}
                {
                selectedUser && 
               <Flex align={'center'} gap={'3'} wrap={'wrap'}> 
                <Container> 
               <UserCardRender user={selectedUser} onClick={() => navigateUser()} /> 
               </Container>
                <Button color="red" onClick={() => clearTransaction()}> <Cross1Icon /> </Button> 
               </Flex>
                }
                 
                <Container className="mt-5">
                    <Container className="mb-3"> 
                    <Text>
                        Количество
                    </Text>
                    <TextField.Root type="number" placeholder="1000" value={amount} onChange={e => setAmount(e.target.value)}>

                    </TextField.Root>
                    </Container>

                    <Container className="mb-3"> 
                    <Text>
                        Сообщение
                    </Text>
                     <TextArea rows={7} placeholder="Привет, хочу вернуть долг" value={message} onChange={e => setMessage(e.target.value)}></TextArea>
                    </Container>

                    <Container className="mt-5">
                        <Button loading={isLoadingFetchSendMoneys} disabled={transaction ? true : false} onClick={async () => fetchSendMoneys()}>
                            Отправить
                        </Button>

                    </Container>

                    {
                        transaction ?
                        <Container className="mb-3">
                        <Text weight={'bold'}>
                            Введите код с почты
                        </Text>
                        <OtpInput 
                        value={mfa}
                        onChange={setMfa}
                        numInputs={6}
                        className="border h-[50px] w-[40px] rounded-[10px]"
                        containerStyle={{display: 'flex', gap: '5px', alignItems: 'center'}}
                        inputStyle={{height: '45px', width: '35px', borderRadius: '10px'}}
                        ref={refOtp}
                        />
                    <Container className="mt-3 mb-3">
                        <Button variant='ghost' onClick={async () => await fetchSendNewCode()} loading={isLoadingSendNewCode}>Отправить еще раз</Button>
                    </Container>
                    <Button color="grass" onClick={async () => await fetchSendMoneysFinish()} loading={isLoadingFetchSendMoneysFinish}>Подтвердить</Button>
                    </Container>
                       :
                       ''
                    }

                </Container>
            </Container>
        </Container>
    )
}